<template>
  <el-header class="me-area base-header">
    <el-row class="me-header">

      <el-col :span="2" :offset="myOffset2" class="me-header-left reset-header-left">
        <router-link to="/" class="me-title">
          <img src="../assets/img/infotikxLogo.svg" />

        </router-link>

      </el-col>

      <el-col :span="12" :offset="myOffset0" style=" width: auto;">
        <el-menu :router=true :default-active="activeIndex" mode="horizontal" menu-trigger="hover"
          active-text-color="#135BFF">
          <!-- 动态路由 -->
          <b v-for="m in routerLabel" :key="m.id">
            <el-menu-item v-if="m.subMenu == null" :index="m.routeIndex + ''">{{ m.routeName }}</el-menu-item>
            <el-menu-item v-if="m.subMenu != null && m.subMenu.length == 1" :index="m.subMenu[0].routeIndex + ''">{{
              m.routeName }}</el-menu-item>
            <el-submenu v-if="m.subMenu != null && m.subMenu.length > 1" :index="m.routeIndex + ''">
              <template slot="title">{{ m.routeName }}</template>
              <el-menu-item v-if="m.subMenu === null" :index="m.routeIndex + ''">{{ m.routeName }}</el-menu-item>
              <el-menu-item v-for="sm in m.subMenu" :key="sm.id" :index="sm.routeIndex + ''">{{ sm.routeName }} <a
                  v-if="sm.id == 53">￥{{ money }}</a></el-menu-item>
            </el-submenu>
          </b>

          <!-- <el-menu-item v-for="r in routerLabel" :key="r.id" :index="r.routeIndex">{{r.routeName}}</el-menu-item> -->
          <!-- <el-submenu v-for="m in routerLabel" :key="m.id" :index="m.routeIndex+''">
            <template slot="title">{{m.routeName}}</template>
            <el-menu-item v-if="m.subMenu === null" :index="m.routeIndex+''">{{m.routeName}}</el-menu-item>
            <el-menu-item v-for="sm in m.subMenu" :key="sm.id" :index="sm.routeIndex+''">{{sm.routeName}}</el-menu-item>
          </el-submenu> -->

          <!-- <el-menu-item index="/category/all">文章分类</el-menu-item> -->
          <!-- <el-menu-item index="/tag/all">标签</el-menu-item> -->
          <!-- <el-menu-item index="/archives">文章归档</el-menu-item> -->
          <!-- <el-submenu> -->
          <!-- <template slot="title">{{$t('common.project')}}</template> -->
          <!-- <el-menu-item index="/editProject">编辑项目</el-menu-item> -->
          <!-- 卖家才可以发布项目 -->
          <!-- <el-menu-item index="/postProject" v-if="user.typeCode == 1"><i class="el-icon-edit"></i>{{$t('project.postProject')}}</el-menu-item> -->
          <!-- <el-menu-item index="/myProject"><i class="el-icon-folder-opened"></i>{{$t('common.myProject')}}</el-menu-item> -->
          <!-- </el-submenu> -->
          <!-- <el-menu-item index="/log">日志</el-menu-item> -->
          <!-- <el-menu-item index="/feedback">留言板</el-menu-item> -->

          <!-- <el-col :span="2" :offset="myOffset1">
            <el-menu-item index="/write"><i class="el-icon-edit"></i>写文章</el-menu-item>
          </el-col> -->
        </el-menu>
      </el-col>

      <div @click="drawer = !drawer" style="margin-top: 18px; float: right; margin-left: 6px;" class="mini-menu pointer">
        三
      </div>  


      <!-- 切换语言 -->

      <el-col :span="4" :offset="myOffset0" style="float: right;width:auto">
        <el-menu :router=true menu-trigger="hover" mode="horizontal" active-text-color="#5FB878">
          <template v-if="!user.login">
            <el-menu-item>
              <!-- <el-button type="text">登录</el-button> -->
              <el-button type="text" data-router="/login" @click="goLogin('/login')" style="color:#135BFF">{{
                $t('common.login') }}</el-button>
            </el-menu-item>
            <el-menu-item>
              <!-- <el-button type="text">注册</el-button> -->
              <el-button type="text" data-router="/register" @click="goLogin('/register')" class="signUp">{{
                $t('common.signUp') }}</el-button>
            </el-menu-item>
          </template>

          <template v-else>
            <el-submenu index="">
              <template slot="title">
                <el-avatar :src="user.avatar">
                  <i class="el-icon-s-custom" style="font-size: 30px;"></i>
                </el-avatar>
                <!--                <span v-if="getTypeCode==1">{{ $t('common.customer') }}</span>-->
                <!--                <span v-if="getTypeCode==2">{{ $t('common.analyst') }}</span>-->
                <span>{{ user.nickname }}</span>

              </template>
              <el-menu-item v-if="getTypeCode == 2" :index="`/u/${user.nickname}`"><i class="el-icon-tickets">
                </i>{{ $t('role.resume') }}</el-menu-item>
              <el-menu-item index="/user/myInformation"><i class="el-icon-user"></i>{{ $t('common.set') }}</el-menu-item>
              <!-- <el-menu-item index="/user/myInformation"><i class="el-icon-user"></i>{{$t('user.personal')}}</el-menu-item> -->
              <el-menu-item v-if="getTypeCode < 3" @click="openRoleSelection()"><i class="el-icon-refresh"></i>{{
                $t('role.changeRole') }}</el-menu-item>
              <el-menu-item v-if="getTypeCode < 3" index="/vipCenter"><i class="el-icon-goods"></i>{{ $t('vip.vip') }}</el-menu-item>

              <el-menu-item v-if="getTypeCode < 3" index="/myPoints"><i class="el-icon-coin"></i>{{ $t('points.myPoints') }}</el-menu-item>

              <el-menu-item index="/help"><i class="el-icon-service"> </i>{{ $t('common.supports') }}</el-menu-item>
              <el-menu-item @click="logout"><i class="el-icon-back"></i>{{ $t('common.logOut') }}</el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </el-col>
      <div v-if="navShowByTypeCode" @click="goChatting" class="fr header-icon">
        <el-badge :value="unreadChatCount" :max="99" :hidden="unreadChatCount == 0">
          <i class="el-icon-chat-dot-square" v-if="((unreadChatCount == 0) || unreadChatCount == null)"></i>
          <i class="el-icon-chat-dot-round round-an" v-if="(unreadChatCount > 0)"></i>
        </el-badge>
      </div>
      <div>  
    <!-- <audio preload="auto" style="display: none;" ref="audioElement" :src="require('@/assets/video/messageNotice.mp3')"></audio>   -->
  </div> 
      <!-- 聊天新版本 -->
      <!-- <div v-if="navShowByTypeCode" @click="goChatting" class="fr header-icon">
        <el-badge :value="unreadChatCount" :max="99" :hidden="unreadChatCount == 0">
          <i class="el-icon-chat-dot-square" v-if="((unreadChatCount == 0) || unreadChatCount == null)"></i>
          <i class="el-icon-chat-dot-round round-an" v-if="(unreadChatCount > 0)"></i>
        </el-badge>
      </div> -->
      <router-link v-if="navShowByTypeCode" to='/MsgCenter' class="fr header-icon">
        <el-badge :value="msgCount" :max="9" :hidden="msgCount == 0">
          <i class="el-icon-bell" v-if="(msgCount == 0)"></i>
          <i class="el-icon-message-solid new-msg" v-if="(msgCount > 0)"></i>
        </el-badge>
      </router-link>
      
      <div style="margin-top: 20px; float: right; margin-right: 6px;">
        <img :src="require('@/assets/img/en.svg')" v-if="lang == 'zh'" @click="changeLang('en')"
          :title="$t('common.changeLang')" style="cursor: pointer;" />
        <img :src="require('@/assets/img/zh.svg')" v-if="lang == 'en'" @click="changeLang('zh')"
          :title="$t('common.changeLang')" style="cursor: pointer;" />
        <!-- <el-select v-model="lang" @change="changeLang" size="mini" style="width: 100px;">
          <el-option
            v-for="lang in langs"
            :key="lang.key"
            :label="lang.value"
            :value="lang.key"
            >
          </el-option>
        </el-select> -->
      </div>
      <div class="searcher" v-if='getTypeCode != 3 && getTypeCode != 4'>
        <el-input v-model="search" class="input-with-select">
          <el-select v-model="select" slot="prepend" v-if="!user.login">
            <el-option :label="$t('index.talent')" value="1"></el-option>
            <el-option :label="$t('index.project')" value="2"></el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-search" @click="goSearchPage"></el-button>
        </el-input>
      </div>
      
    </el-row>

    <!-- 角色选择 -->
    <el-dialog :visible.sync="roleSelection" width="580px" class="changeRole" :close-on-click-modal="false" :modal="true">
      <div style="text-align: center; margin-bottom: 50px;">
        <h2>{{ $t('role.changeRole') }}</h2>
      </div>
      <div>
        <div>
          <tr>
            <td>
              <div style="width: 270px; text-align: center;">
                <div id="role-customer" class="role-checked" @click="choseRole(1)">
                  <img :src="require('@/assets/img/user_role_cus.svg')" style="margin-top: 16px;" />
                  <h4>{{ $t('common.customer') }}</h4>
                </div>
                <div style="width: 220px; margin: 0 auto;">
                  <span>{{ $t('user.chooseRoleCusExplain') }}</span>
                </div>
              </div>
            </td>
            <td>
              <div style="width: 270px; text-align: center;">
                <div id="role-analyst" class="role-unchecked" @click="choseRole(2)">
                  <img :src="require('@/assets/img/user_role_ana.svg')" style="margin-top: 16px;" />
                  <h4>{{ $t('common.analyst') }}</h4>
                </div>
                <div style="width: 220px; margin: 0 auto;">
                  <span>{{ $t('user.chooseRoleAanExplain') }}</span>
                </div>
              </div>
            </td>
          </tr>
        </div>
      </div>
      <div style="margin-top: 60px; text-align: center;">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" :loading="isChangeLoading" @click="changeRole()" style="width: 300px;">{{
            $t('common.confirm') }}</el-button>
        </span>
      </div>
    </el-dialog>

    <!-- 移动端菜单列表 -->
    <el-drawer :modal="false" direction="ltr" :visible.sync="drawer" :with-header="false" size="250px">
      
      <el-menu :router=true :default-active="activeIndex" menu-trigger="hover" class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
        <template v-if="user.login">
          <el-submenu index="">
                <template slot="title">
                  <el-avatar :src="user.avatar">
                    <i class="el-icon-s-custom" style="font-size: 30px;"></i>
                  </el-avatar>
                  <!--                <span v-if="getTypeCode==1">{{ $t('common.customer') }}</span>-->
                  <!--                <span v-if="getTypeCode==2">{{ $t('common.analyst') }}</span>-->
                  <span>{{ user.nickname }}</span>

                </template>
                <el-menu-item v-if="getTypeCode == 2" :index="`/u/${user.nickname}`"><i class="el-icon-tickets">
                  </i>{{ $t('role.resume') }}</el-menu-item>
                <el-menu-item index="/user/myInformation"><i class="el-icon-user"></i>{{ $t('common.set') }}</el-menu-item>
                <!-- <el-menu-item index="/user/myInformation"><i class="el-icon-user"></i>{{$t('user.personal')}}</el-menu-item> -->
                <el-menu-item v-if="getTypeCode < 3" @click="openRoleSelection()"><i class="el-icon-refresh"></i>{{
                  $t('role.changeRole') }}</el-menu-item>
                <el-menu-item index="/vipCenter"><i class="el-icon-goods"></i>{{ $t('vip.vip') }}</el-menu-item>

                <el-menu-item index="/myPoints"><i class="el-icon-coin"></i>{{ $t('points.myPoints') }}</el-menu-item>

                <el-menu-item index="/help"><i class="el-icon-service"> </i>{{ $t('common.supports') }}</el-menu-item>
                <el-menu-item @click="logout"><i class="el-icon-back"></i>{{ $t('common.logOut') }}</el-menu-item>
          </el-submenu>
        </template>
        <b v-for="m in routerLabel" :key="m.id">
            <el-menu-item v-if="m.subMenu == null" :index="m.routeIndex + ''">{{ m.routeName }}</el-menu-item>
            <el-menu-item v-if="m.subMenu != null && m.subMenu.length == 1" :index="m.subMenu[0].routeIndex + ''">{{
              m.routeName }}</el-menu-item>
            <el-submenu v-if="m.subMenu != null && m.subMenu.length > 1" :index="m.routeIndex + ''">
              <template slot="title">{{ m.routeName }}</template>
              <el-menu-item v-if="m.subMenu === null" :index="m.routeIndex + ''">{{ m.routeName }}</el-menu-item>
              <el-menu-item v-for="sm in m.subMenu" :key="sm.id" :index="sm.routeIndex + ''">{{ sm.routeName }} <a
                  v-if="sm.id == 53">￥{{ money }}</a></el-menu-item>
            </el-submenu>
          </b>
          <template v-if="!user.login">
            <el-menu-item @click.native="goLogin('/login')">
              {{$t('common.login') }}
            </el-menu-item>
            <el-menu-item @click.native="goLogin('/register')">
              {{$t('common.signUp') }}
            </el-menu-item>
          </template>
      </el-menu>

    </el-drawer>
    

  </el-header>
</template>

<script>
import { getUnreadMsgCount } from "@/api/message";
import { getUnreadChatCount } from "@/api/chat";
import { getMenu } from "@/api/menu";
import { changeRole } from "@/api/userRole";
import { getMoney } from "@/api/user";
import { mapState, mapMutations } from 'vuex'
import { getUrlParam,hasUrlParam } from '@/utils'
import { setToken , setExpires,getToken} from '@/request/token'
import {getUserByOtherPlatformAuthAPI,ssoLoginAPI,registerAndLoginAPI} from '@/api/sso'
export default {
  name: "BaseHeader",
  inject: ["reload"], // 接受App那边提供的方法
  props: {
    activeIndex: String,
    simple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      drawer: false,
      roleSelection: false,
      choseUserTypeCode: 1,
      fileUrl: this.COMMON.fileUrl,
      showIsDot: false,
      unreadMsgCount: 0,
      unreadChatCount: 0,
      myOffset0: 0,
      myOffset1: 1,
      myOffset2: 2,
      lang: this.$i18n.locale,
      msgCountTimer: null,
      chatCountTimer: null,
      isChangeLoading: false,
      routerLabel: [
        {
          routeIndex: "/",
          routeName: this.$i18n.locale === "en" ? "Home" : "首页"
        },
        {
          routeIndex: "/searchTalent",
          routeName: this.$i18n.locale === "en" ? "To hire" : "找人才"
        },
        {
          routeIndex: "/searchProject",
          routeName: this.$i18n.locale === "en" ? "Find work" : "找工作"
        },
        {
          routeIndex: "/help",
          routeName: this.$i18n.locale === "en" ? "Help" : "帮助"
        }
      ],

      //new
      options: [
        {
          value: "2",
          label: "项目"
        },
        {
          value: "1",
          label: "人才"
        }
      ],
      value: "",
      restaurants: [],
      state: "",
      timeout: null,
      search: "",
      select: "1",
      money: null
    };
  },
  computed: {
    ...mapState(['msgCount']),
    user() {
      let login = this.$store.state.account.length != 0;
      let avatar = null;
      if (this.$store.state.avatar != null) {
        avatar = this.fileUrl + this.$store.state.avatar;
      }
      let nickname = this.$store.state.nickname;
      let account = this.$store.state.account;
      return {
        login,
        avatar,
        nickname,
        account
      };
    },
    getTypeCode() {
      return this.$store.state.typeCode;
    },
    langs() {
      const langs = [
        { key: "zh", value: "简体中文" },
        { key: "en", value: "English" }
      ];
      return langs;
    },
    navShowByTypeCode() {
      if (this.$store.state.typeCode == 3 || this.$store.state.typeCode == 4) {
        return false;
      }
      if (this.$store.state.typeCode == 1 || this.$store.state.typeCode == 2) {
        return true;
      }
    }
  },
  watch: {
    getTypeCode(newVal, oldVal) {
      //do something

      this.select = newVal;
    }
  },
  mounted() {
    if (this.$store.state.typeCode != "") {
      this.select = this.$store.state.typeCode;
    }
    if (this.$store.state.id) {
      this.getMoney();
    }
    if (this.$store.state.token) {
      this.getMenu();
      this.getUnreadMsgCount(); // 查询用户消息未读数
      this.getUnreadChatCount() // 查询用户在线聊天未读数
      this.scheduledTasks(); // 启动定时任务
      this.$store.dispatch("getUserInfo")
    }else{
      this.sso()
    }
    // 充值成功刷新
    window.eventBus.$on("getMoney", () => {
      this.getMoney();
    });
    //给父窗口绑定一个方法
    window['getChildData'] = (data) => {
      console.log('接受子窗口数据：', data)
      this.getUnreadChatCount()
      // if(data.status == 1) {
      //   this.getUnreadChatCount()
      //   const audio = document.createElement('audio');
      //   audio.src = require('@/assets/video/messageNotice.mp3');
      //   audio.play();
      //   console.log('播放声音')
      // }
      // if(data.status == 2) {
      //   this.getUnreadChatCount()
      // }
    }
  },
  methods: {
    ...mapMutations(['SET_MSG_COUNT']),

    goChatting() {
      // let url = `/#/socketMsg`;
      // window.open(
      //   url,
      //   "chat",
      //   "height=600, width=800, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no"
      // );
      this.$router.push({ path: "/socketMsg" });

    },
    //获取钱包余额
    getMoney() {
      getMoney().then(res => {
        if (res.code == 0) {
          this.money = res.data;
        } else {
        }
      });
    },

    goLogin(src) {
      if (this.$route.query.projectId) {
        sessionStorage.setItem(
          "historyUrl",
          `${this.$route.path}?projectId=${this.$route.query.projectId}`
        );
      }

      this.$router.push({ path: src });
    },
    logout() {
      let that = this;
      this.$store
        .dispatch("logout")
        .then(() => {
          // this.reload();
          this.clearScheduledTasks();
          // this.$router.push({ path: "/" });
          let redirectUrl = encodeURIComponent(process.env.HTML_URL+'?token=');
          let ssoUrl =  process.env.SSO_URL+`add.html?minutes=0&from=infotikx&returnUrl=${redirectUrl}`;
          console.log('ssoUrl', ssoUrl)
          window.location.href = ssoUrl;
        })
        .catch(error => {
          if (error !== "error") {
            that.$message({ message: error, type: "error", showClose: true });
          }
          let redirectUrl = encodeURIComponent(process.env.HTML_URL+'?token=');
          let ssoUrl =  process.env.SSO_URL+`add.html?minutes=0&from=infotikx&returnUrl=${redirectUrl}`;
          console.log('ssoUrl', ssoUrl)
          window.location.href = ssoUrl;
        });
    },
    getUnreadMsgCount() {
      console.info('getUnreadMsgCount.token', this.$store.state.token);
      if (!this.$store.state.token) {
        return;
      }
      // 获取未读消息Count
      getUnreadMsgCount().then(res => {
        if (res.code == 0) {
          this.unreadMsgCount = res.data == 0 ? "" : res.data;
          this.SET_MSG_COUNT(this.unreadMsgCount)
          this.showIsDot =
            res.data == 0 && this.unreadMsgCount == 0 ? false : true;
        }
      });
    },
    // playAudio() {  
    //   const audioElement = this.$refs.audioElement; // 获取音频元素  
    //   audioElement.play(); // 播放音频  
    // },  
    getUnreadChatCount() {
      console.info('getUnreadChatCount.token', this.$store.state.token);
      console.log('更新未读消息数量')   
      if (this.$store.state.token) {
        // 获取未读的Chat消息
        getUnreadChatCount(this.$store.state.id).then(res => {
          if (res.code == 0) {
            // if(res.data > this.unreadChatCount) {
            //   const audio = document.createElement('audio');
            //   audio.src = require('@/assets/video/messageNotice.mp3');
            //   audio.autoplay = true;
            //   audio.play();
            //   this.playAudio()
            //   console.log('播放声音')
            // }
            this.unreadChatCount = res.data == 0 ? "" : res.data;
            this.showIsDot = res.data == 0 && this.unreadChatCount == 0 ? false : true;
          }
        });
      }
    },
    // 定时任务
    scheduledTasks() {
      let $this = this;
      // this.getUnreadMsgCount();
      this.msgCountTimer = setInterval(function () {
        $this.getUnreadMsgCount();
      }, 1000 * 60 * 5);
      // this.getUnreadChatCount();
      this.chatCountTimer = setInterval(function () {
        $this.getUnreadChatCount();
      }, 1000 * 10);
    },
    // 清除定时任务
    clearScheduledTasks() {
      clearInterval(this.msgCountTimer);
      this.msgCountTimer = null;
      clearInterval(this.chatCountTimer);
      this.chatCountTimer = null;
    },
    // 切换语言
    changeLang(lang) {
      // this.lang = (this.lang === 'en'? 'zh': 'en')
      this.$i18n.locale = lang; // 设置当前语言
      // 防止刷新页面时语言回到默认，将当前设置的语言存储在本地
      localStorage.setItem("lang", lang);
      sessionStorage.removeItem("routerLabel");
      this.reload(); //在触发切换语言后调用，相当于直接调用app里写的reload方法
    },
    // 获取用户菜单
    getMenu() {
      let hasLabel = JSON.parse(sessionStorage.getItem("routerLabel"));
      if (hasLabel) {
        this.routerLabel = hasLabel;
      } else {
        getMenu(this.$i18n.locale).then(res => {
          if (res.code == 0) {
            this.routerLabel = res.data;
            const label = JSON.stringify(this.routerLabel);
            sessionStorage.setItem("routerLabel", label);
          }
        });
      }
    },
    //搜索节流
    goSearch(query) {
      if (query != "") {
        const that = this;
        if (!that.statu) {
          return;
        }
        that.statu = false;
        setTimeout(function () {
          // that.getData(query); 调用发起搜索方法
          that.statu = true;
        }, 500);
      }
    },
    goSearchPage() {
      if (this.select == "2") {
        if (this.$route.path == "/searchProject") {
          this.$router.push({
            path: "/searchProject",
            query: { keyWord: this.search }
          });
          this.$router.go(0);
          return;
        }
        this.$router.push({
          path: "/searchProject",
          query: { keyWord: this.search }
        });
      } else {
        if (this.$route.path == "/searchTalent") {
          this.$router.push({
            path: "/searchTalent",
            query: { keyWord: this.search }
          });
          this.$router.go(0);
          return;
        }
        this.$router.push({
          path: "/searchTalent",
          query: { keyWord: this.search }
        });
      }
    },
    openRoleSelection() {
      this.roleSelection = true;
      setTimeout(() => {
        this.choseRole(this.$store.state.typeCode);
      }, 300);
    },
    choseRole(roleCode) {
      this.choseUserTypeCode = roleCode;
      if (roleCode == 1) {
        document.getElementById("role-customer").className = "role-checked";
        document.getElementById("role-analyst").className = "role-unchecked";
      } else {
        document.getElementById("role-analyst").className = "role-checked";
        document.getElementById("role-customer").className = "role-unchecked";
      }
    },
    changeRole() {
      this.isChangeLoading = true;
      changeRole(this.choseUserTypeCode).then(res => {
        this.isChangeLoading = false;
        if (res.code == 0) {
          this.$message({
            message: this.$t("common.successTip"),
            type: "success"
          });
          sessionStorage.removeItem("routerLabel");
          sessionStorage.removeItem("userInfo");
          this.roleSelection = false;
          // this.$router.push({ path: "/" });
          location.reload();
        } else {
          this.$message({
            message: this.$t("common.saveFailed"),
            type: "error"
          });
        }
      });
    },
    //通过其它平台的token登录
    async loginByOtherPlatformTokenToken(otherToken,platformName) {
        const res = await getUserByOtherPlatformAuthAPI(otherToken)
        // console.log('otherToken res', res)
        if(!res.data) return
        if(res.data.platformCode != 'infotikx'){//token所属平台的Code， 使用其他平台Token注册并登录
            this.$confirm(`您已在${platformName}平台登录，是否使用${platformName}账号注册并登录?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(async() => {
                const {data} = await registerAndLoginAPI(otherToken)
                console.log('registerAndLogin data', data)
                const token = data['Oauth-Token']
                setToken(token)
                setExpires(data.expire)
                this.$store.commit('SET_TOKEN', data['Oauth-Token'])
                //向 sso 添加 token
                let redirectUrl = encodeURIComponent(process.env.HTML_URL+"?from=infotikx"); //process.env.HTML_URL+'?from=infotikx'
                let ssoUrl = process.env.SSO_URL+`add.html?infotikx=${token}&minutes=${data.expire}&from=infotikx&returnUrl=${redirectUrl}`;
                window.location.href = ssoUrl;
                // window.location.reload();
            }).catch(() => {});
        }
        if(res.data.platformCode == 'infotikx'){//自身平台的Code，使用其他平台Token登录
            this.$confirm(`您已在${platformName}平台登录，是否使用${platformName}账号登录?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(async() => {
                const {data} = await ssoLoginAPI(otherToken)
                console.log('ssoLogin data', data)
                const token = data['Oauth-Token']
                setToken(token)
                setExpires(data.expire)
                this.$store.commit('SET_TOKEN', data['Oauth-Token'])
                //向 sso 添加 token
                let redirectUrl = encodeURIComponent(process.env.HTML_URL+"?from=infotikx");
                let ssoUrl = process.env.SSO_URL+`add.html?infotikx=${token}&minutes=${data.expire}&from=infotikx&returnUrl=${redirectUrl}`;
                window.location.href = ssoUrl;
                // window.location.reload();
            }).catch(() => {});
        }
    },
    sso() {
        const transToken = this.$route.query.trans;
        const dpsToken = this.$route.query.dps;
        console.log('transToken', transToken)
        console.log('dpsToken', dpsToken)
        if(transToken) {
            this.loginByOtherPlatformTokenToken(transToken,'trans')
            return
        }
        if(dpsToken) {
            this.loginByOtherPlatformTokenToken(dpsToken,'dps')
            return
        }
        if(!hasUrlParam("token")){
            let redirectUrl = encodeURIComponent(window.location.href);
            let ssoUrl = process.env.SSO_URL + `index.html?from=infotikx&returnUrl=${redirectUrl}`;
            console.log('ssoUrl', ssoUrl)
            window.location.href = ssoUrl;
        }
    }
  }
};
</script>

<style lang="scss">

.base-header .el-drawer__body{
  background: #545c64!important;
}
.el-menu-vertical-demo{
  border-right: none;
}
.mini-menu{
  display: none;
}
@media (max-width:1200px) {
  .mini-menu{
    display: block;
  }
  .searcher{
    display: none;
  }
  .me-header .el-menu{
    display: none;
  }
  .el-container{
    padding-bottom: 180px;
  }
}

.el-menu--horizontal{
  border-bottom: none !important;
}
.changeRole .el-dialog {
  z-index: 9999 !important
}

.signUp {
  padding: 0 20px !important;
  height: 40px;
  line-height: 39px !important;
  background: #135bff !important;
  font-size: 14px !important;
  color: #ffffff !important;
  border-radius: 20px !important;
}

.signUp,
.signUp .el-menu-item :hover {
  background: #135bff !important;
}

.el-header {
  position: fixed;
  z-index: 1024;
  /* min-width: 1200px; */
  box-shadow: 0 2px 3px hsla(0, 0%, 7%, 0.1), 0 0 0 1px hsla(0, 0%, 7%, 0.1);
  left: 0;
  right: 0;
  top: 0;
  overflow: hidden;
  height: auto!important;
}

.me-title {
  margin-top: 10px;
  font-size: 24px;
}

.me-header-left {
  margin-top: 14px;
}

.me-header {
  max-width: 1200px;
  margin: 0 auto;
  /* overflow: hidden; */
  background: #fff;
}

.me-title img {
  height: 32px;
  width: 164px;
}

.me-header-picture {
  width: 36px;
  height: 36px;
  border: 1px solid #ddd;
  border-radius: 50%;
  vertical-align: middle;
  background-color: #5fb878;
}

.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 110px;
}

.el-badge__content.is-fixed.is-dot {
  margin-top: 14px;
}

.el-badge__content.is-fixed {
  top: 6px;
}

.reset-header-left {
  margin-left: 0 !important;
  width: auto !important;
}

/* .item {
    margin-top: 10px;
    margin-right: 40px;
  } */
.el-badge__content.is-fixed.is-dot {
  left: -18px !important;
}

.el-badge__content.is-fixed {
  top: 7px !important;
}

.header-icon {
  font-size: 21px;
  padding: 4px;
  margin: 10px;
  cursor: pointer;
  color: #606266;
}

.header-icon:hover {
  color: #135bff;
}

.searcher {
  width: 230px;
  float: right;
  height: 36px;
  margin: 12px 5px;
  border-radius: 20px;
  border: 1px solid #dcdfe6;
  overflow: hidden;
  position: relative;
  margin-right: 15px;
}



.searcher .el-select .el-input {
  width: 96px;
}

.searcher .input-with-select,
.searcher .el-input-group__prepend,
.searcher .el-input__inner,
.searcher .el-button,
.searcher .el-input-group__append {
  background-color: #fff;
  border: none;
}

.el-input-group__prepend {
  border-radius: 20px;
}

.role-checked {
  width: 120px;
  height: 120px;
  margin: 0 auto;
  margin-bottom: 16px;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #135bff;
  background: rgba(19, 91, 255, 0.1);
  cursor: pointer;
}

.role-unchecked {
  width: 120px;
  height: 120px;
  margin: 0 auto;
  margin-bottom: 16px;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #c9cdd4;
  cursor: pointer;
}

.round-an {
  animation: ringing 3s infinite ease 1s;
  transform-origin: 50% 0%;
}

.new-msg {
  animation: ringing 3s infinite ease 1s;
  transform-origin: 50% 0%;
}

.v-modal {
  z-index: 999 !important
}

@keyframes ringing {
  0% {
    transform: rotate(-15deg);
  }

  2% {
    transform: rotate(15deg);
  }

  4% {
    transform: rotate(-18deg);
  }

  6% {
    transform: rotate(18deg);
  }

  8% {
    transform: rotate(-22deg);
  }

  10% {
    transform: rotate(22deg);
  }

  12% {
    transform: rotate(-18deg);
  }

  14% {
    transform: rotate(18deg);
  }

  16% {
    transform: rotate(-12deg);
  }

  18% {
    transform: rotate(12deg);
  }

  20% {
    transform: rotate(0deg);
  }
}

</style>



// WEBPACK FOOTER //
// src/views/BaseHeader.vue